export const ACTION_LOADING: number = 400;
export type SEGMENT_TYPES =
  | 'perimeter-units'
  | 'key-moments'
  | 'near-goal'
  | 'earned-media';
